

































import { Component } from 'vue-property-decorator';
import { mapActions, mapGetters } from 'vuex';
import {
    ResetPasswordFormData,
    ResetPasswordRequest,
} from '@/model/ResetPassword';
import ResetPasswordForm from '@/components/reset-password/ResetPasswordForm.vue';
import ToastMixin from '@/mixins/ToastMixin';
import { mixins } from 'vue-class-component';
import { checkTokenExpired, parseToken } from '@/lib/helper/token-helper';
import ToastVariant from '@/model/enums/toast/toast-variant';
import SignupResetPasswordLayout from '@/components/layout/SignupResetPasswordLayout.vue';
import Selector from '@/components/language/Selector.vue';

@Component({
    components: {
        ResetPasswordForm,
        SignupResetPasswordLayout,
        Selector,
    },
    methods: {
        ...mapActions({
            resetPassword: 'resetPasswordStorage/resetPassword',
        }),
    },
    computed: mapGetters({
        resetError: 'resetPasswordStorage/getError',
    }),
})
export default class ResetPassword extends mixins(ToastMixin) {
    loading = false;

    resetPassword!: (request: ResetPasswordRequest) => Promise<void>;

    mounted(): void {
        this.$store.commit('resetPasswordStorage/setError', null);

        if (this.isTokenExpired) {
            this.pushToLogin(
                this.$t('reset-password.notification.token-expired').toString(),
                this.$t('reset-password.notification.title').toString(),
                ToastVariant.DANGER,
            );
        }
    }

    get email(): string {
        let email = '';

        try {
            email = parseToken(this.$route.query.token as string).sub;
        } catch {
            this.pushToLogin(
                this.$t(
                    'reset-password.notification.failed-to-parse-token',
                ).toString(),
                this.$t('reset-password.notification.title').toString(),
                ToastVariant.DANGER,
            );
        }

        return email;
    }

    get isTokenExpired(): boolean {
        let isExpired: boolean;

        try {
            isExpired = checkTokenExpired(this.$route.query.token as string);
        } catch {
            isExpired = false;
        }

        return isExpired;
    }

    pushToLogin(message: string, title: string, variant: ToastVariant): void {
        this.$router.push({ name: 'Login' }).then(() => {
            this.$nextTick(() => {
                this.showToast(message, title, variant);
            });
        });
    }

    onSubmit(formData: ResetPasswordFormData): void {
        this.loading = true;

        this.resetPassword({
            password: formData.password,
            token: this.$route.query.token as string,
        })
            .then(() => {
                const emailAddress = this.email;

                this.pushToLogin(
                    this.$t('reset-password.notification.reset-successful', {
                        email: emailAddress,
                    }).toString(),
                    this.$t('reset-password.notification.title').toString(),
                    ToastVariant.SUCCESS,
                );
            })
            .finally(() => {
                this.loading = false;
            });
    }
}
